import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

const pricingModalStyles = {
	modalWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		width: { xs: '90vw', sm: '80vw' },
		maxHeight: '80vh',
		maxWidth: '1100px',

		overflowY: 'auto',
	},
	modalBody: {
		padding: { xs: '24px 16px', [tabletBreakpoint]: '24px 80px' },
		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: 'colors.dark3',
		borderRadius: '12px',

		backgroundColor: 'colors.dark6',
		textAlign: 'center',

		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '40px',

		position: 'relative',
	},
	crossButton: {
		position: 'absolute',
		top: '24px',
		right: '24px',

		minWidth: 'unset',
		padding: 0,

		zIndex: 1,

		'& svg': {
			stroke: colorPalette.light5,
		},
		'&.Mui-disabled': {
			'& svg': {
				stroke: colorPalette.light5,
			},
		},
	},
	cross: { height: '24px', width: 'auto' },
	subtitle(isHighlighted) {
		return {
			width: 'fit-content',
			alignSelf: 'center',
			padding: isHighlighted ? '0px 8px' : '0',
			color: isHighlighted ? 'colors.dark4' : 'colors.light4',
			backgroundColor: isHighlighted ? 'colors.systemYellow' : 'transparent',
			borderRadius: isHighlighted ? '8px' : '0',
		};
	},
};

export { pricingModalStyles };
